import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsListComponent } from './forms-list/forms-list.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormsRoutingModule } from './forms-routing.module';
import { SellerPfModule } from './seller-pf/seller-pf.module';
import { SellerPjModule } from './seller-pj/seller-pj.module';
import { SellerPfRoutingModule } from './seller-pf/seller-pf-routing.module';
import { SellerPjRoutingModule } from './seller-pj/seller-pj-routing.module';
import { SellerSuccessComponent } from './seller-success/seller-success.component';
import { PropertyDivisionPjModule } from './property-division/property-division-pj/property-division-pj.module';
import { PropertyDivisionPfModule } from './property-division/property-division-pf/property-division-pf.module';

const baseModule = [CommonModule, ReactiveFormsModule, SharedModule];

const formsModule = [
  FormsModule,
  FormsRoutingModule,
  SellerPfModule,
  SellerPfRoutingModule,
  SellerPjModule,
  PropertyDivisionPjModule,
  PropertyDivisionPfModule,
  SellerPjRoutingModule,
];

@NgModule({
  declarations: [FormsListComponent, SellerSuccessComponent],
  imports: [baseModule, formsModule, SharedModule],
  providers: [],
  bootstrap: [],
  exports: [FormsListComponent, SellerSuccessComponent],
})
export class FormsProposalModule {}
